import { jsxs as l, jsx as r } from "react/jsx-runtime";
function h(i) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ r("g", { "clip-path": "url(#clip0_266003_10873)", children: /* @__PURE__ */ r(
          "path",
          {
            d: "M0 5.33333V4.66667C0 2.82867 1.49533 1.33333 3.33333 1.33333H4V0.666667C4 0.298667 4.298 0 4.66667 0C5.03533 0 5.33333 0.298667 5.33333 0.666667V1.33333H10.6667V0.666667C10.6667 0.298667 10.9647 0 11.3333 0C11.702 0 12 0.298667 12 0.666667V1.33333H12.6667C14.5047 1.33333 16 2.82867 16 4.66667V5.33333H0ZM16 6.66667V12.6667C16 14.5047 14.5047 16 12.6667 16H3.33333C1.49533 16 0 14.5047 0 12.6667V6.66667H16ZM11.888 8.768C11.632 8.50333 11.2107 8.49533 10.9453 8.75067L7.776 11.8053C7.52533 12.056 7.10467 12.0747 6.81667 11.788L5.298 10.3767C5.02933 10.1267 4.608 10.1407 4.356 10.4113C4.10533 10.6807 4.12067 11.1027 4.39067 11.3533L5.892 12.748C6.26933 13.126 6.772 13.334 7.306 13.334C7.84 13.334 8.34333 13.126 8.71133 12.7567L11.8713 9.71133C12.136 9.456 12.144 9.03267 11.888 8.768Z",
            fill: "rgb(var(--brand-primary))"
          }
        ) }),
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ r("clipPath", { id: "clip0_266003_10873", children: /* @__PURE__ */ r("rect", { width: "16", height: "16", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
export {
  h as CalendarWithCheckIcon
};
